module.exports = __webpack_public_path__ + "static/media/fire-evac.75773973.png";